import { useTranslation } from "react-i18next";

import { AuditAlertSeverity } from "../../auditLog.types";
import { SEVERITY_COLORS } from "../../constants";

import styles from "./SeverityBadge.module.scss";

interface SeverityBadgeProps {
  severity: AuditAlertSeverity;
}

const SeverityBadge = ({ severity }: SeverityBadgeProps) => {
  const { t } = useTranslation();
  const color = SEVERITY_COLORS[severity];

  return (
    <span
      className={styles.badge}
      style={{ color, backgroundColor: `${color}1a` }}
    >
      {t(severity)}
    </span>
  );
};

export default SeverityBadge;
